<template>
  <v-dialog
    :value="show"
    width="800px"  
    @input="$emit('changeValue', $event)">
    <v-card class="px-4 pt-4 pb-4" height="562px">
      <v-card-title>
        <h2>
          Elegir método de contacto
        </h2>
      </v-card-title>
      <v-card-text>
        <vue-perfect-scrollbar>
        <v-layout column py-2 px-4 class="scroll">
          <v-flex pb-3>
            <data-table
            :url="`customers/${customerId}/contact`">
              <template slot="content" slot-scope="props">
                <template v-for="(item, i) in props.items">
                  <v-list-tile
                    :key="`customer-${i}`"
                    v-on="{ click: () => item.email ? makeChatCenter(item, 1) : openMenu(i) } "
                    avatar>
                    <v-list-tile-avatar>
                      <v-icon class="k-orange-linear-text" large>
                        fas fa-{{item.phone ? 'phone fa fa-rotate-90' : 'envelope'}}
                      </v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <strong>
                          {{ item.email || item.phone }}
                        </strong>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="item.phone">
                      <v-menu v-model="showMenu[i]" bottom offset-y @click.native.stop>
                        <v-btn slot="activator" color="grey darken-2" small flat fab>
                          <v-icon>fas fa-ellipsis-v</v-icon>
                        </v-btn>
                        <v-list>
                          <v-list-tile  @click.stop="makeChatCenter(item, 2)">
                            <v-list-tile-title> 
                              <v-icon class="k-orange-linear-text">
                                fas fa-comments
                              </v-icon>
                              Sms
                            </v-list-tile-title>
                          </v-list-tile>
                          <!-- <v-list-tile  @click.stop="makeChatCenter(item.phone, 7)">
                            <v-list-tile-title> 
                              <v-icon class="k-orange-linear-text">
                                fab fa-whatsapp
                              </v-icon>
                              Whatsapp
                            </v-list-tile-title>
                          </v-list-tile> -->
                        </v-list>
                      </v-menu>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider
                    v-if="i !== props.items.length - 1"
                    :key="`divider${i}`">
                  </v-divider>
                </template>
              </template>
            </data-table>
          </v-flex>
        </v-layout>
        </vue-perfect-scrollbar>
      </v-card-text>
      <v-card-actions>
        <v-layout>
          <v-flex class="text-xs-right xs12" pr-4>
            <v-btn flat color="black" @click="$emit('changeValue', false)">
              Cerrar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import DataTable from '@/components/global/DataTable2';

export default {
  props: {
    customerId: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VuePerfectScrollbar,
    DataTable,
  },
  data() {
    return {
      showMenu: [],
    };
  },
  methods: {
    openMenu(id) {
      if (!this.showMenu[id]) {
        this.$set(this.showMenu, id, true);
      }
    },
    makeChatCenter(contact, channel) {
      let internal_id = channel === 1 ? contact.email : contact.phone;
      if (this.$auth.user().company_id !== 18622237) {
        this.$emit('selected', {
          internal_id: internal_id,
          channel_id: channel,
          contact_id: contact.id,
        });
      }
    },
  },
};
</script>
<style scoped>
.scroll {
  height: 385px;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/PickContactMethod.vue